// Module: accounts — «الحسابات» (HANDOFF §3). Each accounts item lives in its
// own sub-folder and contributes routes + menu rows here. Menu order is
// HANDOFF §3: كشوف الحسابات · (الفواتير — no list board, Q-IN1) · السندات ·
// الصناديق · الذمم · ذمم الموردين · الأقساط · المصروفات · القيود · دفتر الأستاذ ·
// مطابقة البنك · إقفال الفترة. The global «فترة مقفلة» dialog host lives in
// ./close and is mounted once by the shell (AppShell + makeQueryClient).

import { Calculator } from 'lucide-react';
import { defineModule } from '@/app/module-types';
import { bankMenu, bankRoutes } from './bank';
import { closeMenu, closeRoutes } from './close';
import { documentsMenu, documentsRoutes } from './documents';
import { installmentsMenu, installmentsRoutes } from './installments';
import { ledgerMenu, ledgerRoutes } from './ledger';
import { payablesMenu, payablesRoutes } from './payables';
import { expensesMenu, vouchersMenu, vouchersRoutes } from './vouchers';

export default defineModule({
  key: 'accounts',
  label: 'الحسابات',
  icon: Calculator,
  flag: 'erp.accounts',
  minRole: 'staff',
  rail: 'accounts',
  routes: [...documentsRoutes, ...vouchersRoutes, ...payablesRoutes, ...installmentsRoutes, ...ledgerRoutes, ...bankRoutes, ...closeRoutes],
  menu: [
    ...documentsMenu.filter((i) => i.key === 'statements'),
    ...vouchersMenu,
    ...documentsMenu.filter((i) => i.key !== 'statements'),
    ...payablesMenu,
    ...installmentsMenu,
    ...expensesMenu,
    ...ledgerMenu,
    ...bankMenu,
    ...closeMenu,
  ],
});
